<template>
    <div
        class="BaseModal"
    >
        <transition name="modal">
            <div
                class="BaseModal__mask"
                v-if="isActive"
            >
                <div
                    class="container"
                >
                    <div class="BaseModal__content">

                        <BaseButton
                            @click="toggle"
                            modifier="squared"
                            tag="button"
                        >
                            <BaseIcon
                                icon="cross-icon"
                                color="white"
                            />
                        </BaseButton>

                        <BaseImage
                            v-if="image"
                            :srcset="image"
                            :ratio="ratio"
                            class="BaseModal__image"
                        />

                    </div>
                </div>
            </div>
        </transition>
        <button
            @click="toggle"
        >
            <slot />
        </button>
    </div>
</template>
<script>
import { toggleState } from '@mixins/toggleState.js'
import { toggleBodyClass } from '@mixins/toggleBodyClass.js'
export default {
    name: 'BaseModal',
    mixins: [toggleBodyClass, toggleState],
    props: {
        image: {
            type: String,
            default: null
        },
        ratio: {
            type: Number,
            default: null
        }
    },
    methods: {
        toggle() {
            this.toggleBodyClass('nav-is-active');
            this.toggleState();
        }
    }
}
</script>
<style lang="scss" scoped>
    .BaseModal__mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background: rgba($action-color, .75);
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity .3s ease;

        > .container {
            width: 100%;
            padding-right: getSpacing('spacer');
            padding-left: getSpacing('spacer');
        }
    }

    .BaseModal__content {
        position: relative;
        background: getColor('white');
        width: 100%;
        border-radius: 2px;
        transition: all .3s ease;
    }

    .BaseButton {
        position: absolute;
        z-index: 2;
        right: 1px;
        top: 1px;
        font-size: 16px;
    }

    .BaseImage {
        &:after {
            display: none;
        }
    }

    .modal-enter {
        opacity: 0;
    }

    .modal-leave-active {
        opacity: 0;
    }

    .modal-enter .BaseModal__content,
    .modal-leave-active .BaseModal__content {
        transform: scale(1.1);
    }
</style>
